/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: Jeremy Edelblut (https://sketchfab.com/jeremy.toys)
license: CC-BY-SA-4.0 (http://creativecommons.org/licenses/by-sa/4.0/)
source: https://sketchfab.com/3d-models/3mojiorg-zany-face-661963bc16e84c81a1cce9a692e97ce4
title: 3moji.org : Zany Face
*/

import React, { useRef, useMemo } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from 'react-three-fiber'
import gsap from 'gsap'

export function Face(props) {
  const faceRef1 = useRef(null)
  const faceRef2 = useRef(null)
  const faceRef3 = useRef(null)

  const refs = [faceRef1, faceRef2, faceRef3]


  const positions = useMemo(
    () =>
      [...new Array(3)].map(() => [
        3 - Math.random() * 6,
        Math.random() * 4,
        3 - Math.random() * 6,
      ]),
    []
  )
  const easeInOutCubic = t =>
    t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
  const factor = useMemo(() => 0.5 + Math.random(), [])
  useFrame(state => {
    const t = easeInOutCubic(
      (1 + Math.sin(state.clock.getElapsedTime() * factor)) / 2
    )
    faceRef1.current.position.y = 1 + t * 4
    faceRef1.current.scale.y = 1 + t * 3
  })
  useFrame(
    state =>
      (faceRef1.current.rotation.y =
        Math.sin(state.clock.getElapsedTime() / 2) * Math.PI)
  )
  useFrame(() => {
    faceRef2.current.rotation.y += 0.004
    faceRef2.current.rotation.x += 0.004
    faceRef2.current.rotation.z += 0.004
  })
  useFrame(() => {
    faceRef3.current.rotation.y += 0.004
    faceRef3.current.rotation.x += 0.004
    faceRef3.current.rotation.z += 0.004
  })

  const { nodes, materials } = useGLTF('/face.glb')

  return (
    <>
      {positions.map((pos, index) => (
        <group key={index} position={pos} dispose={null}>
          <group rotation={[-Math.PI / 2, 0, 0]}>
            <group rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                ref={refs[index]}
                castShadow
                geometry={nodes.Object_4.geometry}
                material={materials.color}
              />
            </group>
          </group>
        </group>
      ))}
    </>
  )
}

useGLTF.preload('/face.glb')
